import { render, staticRenderFns } from "./OpenSourceSection.vue?vue&type=template&id=61b4179c&scoped=true&"
import script from "./OpenSourceSection.vue?vue&type=script&lang=js&"
export * from "./OpenSourceSection.vue?vue&type=script&lang=js&"
import style0 from "./OpenSourceSection.vue?vue&type=style&index=0&id=61b4179c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b4179c",
  null
  
)

export default component.exports